/* eslint-disable */
import React from 'react';

const IconSearch = () => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.7 20.29l-4.35-4.35c-.4-.4-1.03-.4-1.42 0 -.4.39-.4 1.02 0 1.41l4.35 4.35c.39.39 1.02.39 1.41 0 .39-.4.39-1.03 0-1.42Zm-3.71-9.3c0 3.86-3.14 7-7 7 -3.87 0-7-3.14-7-7 0-3.87 3.13-7 7-7 3.86 0 7 3.13 7 7Zm2 0c0-4.98-4.03-9-9-9 -4.98 0-9 4.02-9 9 0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9Z" />
    </svg>
);

export default IconSearch;
